import firebase from "firebase/app";
import axios from "axios";
const mainURL = 'https://evening-waters-31817.herokuapp.com/'
// const mainURL = 'http://localhost:5000/allMarkets'
const COIN_GECKO_API = 'https://api.coingecko.com/api/v3'

export default {
    state: {
        dashboard: []
    },
    mutations: {
        setDashboard: (s, d) => s.dashboard = d,
        addTile: (s, t) => s.dashboard.push(t),
    },

    getters: {
        getDashboard: (s) => s.dashboard,
    },
    actions: {
        async updateObject({ dispatch, commit, getters }, { text, id }) {
            try {
                const uid = await dispatch('getUid');
                await firebase.database().ref(`/users/${uid}/dashboard`).child(id).update({ props: text });
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        changeTilesInitPosition: ({ commit }, tiles) => {
            const WW = window.innerWidth;
            tiles.map(tile => {

                // tile.w = WW < 600 ? 12 : 4
                // tile.h = WW < 600 ? 4 : 5

                // tile.maxH = WW < 600 ? 8 : 6
                // tile.maxW = WW < 600 ? 12 : 6

                // tile.maxW = tile.tileType === 'ticker-tile' && WW < 600
                //     ? tile.maxW : 12;
                // tile.h = tile.tileType === 'ticker-tile' && WW > 600
                //     ? tile.h : 4;

                if (tile.tileType === 'note-tile') {
                    tile.maxH = WW < 600 ? 8 : 6
                    tile.maxW = WW < 600 ? 12 : 5;
                    tile.minH = WW < 600 ? 5 : 3
                    tile.minW = WW < 600 ? 12 : 3
                    tile.h = WW < 600 ? 5 : 5;

                }

                if (tile.tileType === 'ticker-tile') {
                    tile.maxH = WW < 600 ? 8 : 6
                    tile.maxW = WW < 600 ? 12 : 5;
                    tile.minH = WW < 600 ? 4 : 5
                    tile.minW = WW < 600 ? 12 : 4

                    tile.h = WW < 600 ? 5 : tile.h;
                }

                if (tile.tileType === 'wallet-tile') {
                    tile.maxH = WW < 600 ? 8 : 7
                    tile.maxW = WW < 600 ? 12 : 5;
                    tile.h = WW > 600 ? tile.h : 4;
                    tile.minH = WW < 600 ? 5 : 4
                    tile.minW = WW < 600 ? 12 : 3
                }
                tile.w = WW < 600 ? 12 : tile.w;



            })
            commit('setDashboard', tiles)
        },
        async syncDashboard({ dispatch, commit, getters }) {
            console.log('Sync dashboard state');
            const dashboard = getters.getDashboard;
            let data = {}
            Object.values(dashboard).map((tile) => (data[tile.key] = tile));
            try {
                const uid = await dispatch('getUid');
                await firebase.database().ref(`/users/${uid}/dashboard`).update(data);
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        async fetchDashboard({ dispatch, commit }) {
            try {
                const uid = await dispatch('getUid');
                const data = (await firebase.database().ref(`/users/${uid}/dashboard`).once('value')).val() || {}
                const dashboard = Object.entries(data).map(([key, tile]) => ({ key, ...tile }));
                dispatch('changeTilesInitPosition', dashboard)
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        async addTile({ dispatch, commit }, { tile }) {
            try {
                const uid = await dispatch('getUid')
                await firebase.database().ref(`/users/${uid}/dashboard`).push(tile);
                await dispatch('fetchDashboard');
            } catch (e) {
                commit('setError', e)
                throw e
            }

        },
        async deleteTile({ commit, dispatch }, key) {
            try {
                const uid = await dispatch('getUid')
                await firebase.database().ref(`/users/${uid}/dashboard`).child(key).remove();
                await dispatch('fetchDashboard');
            } catch (e) {
                commit('setError', e)
                throw e
            }
        },
        async globalMetrics({ dispatch, commit }) {
            return await axios.get(COIN_GECKO_API + '/global')
                .then(response => response.data.data)
                .catch(error => error)
        },

        async allWallets({ dispatch, commit }) {
            try {

                return await axios({
                    method: 'GET',
                    url: mainURL + '/wallets',

                }).then(response => {
                    console.log('RESPONSE', response)
                    return response
                }).catch(error => { console.log(error) })
            } catch (e) {
                commit('setError', e);
                throw e;
            }
        },
    }
}